export default "<h1>Type2Link list</h1>\n<spec-app-type2-link-table [clickHandler]=\"createClickHandler()\"></spec-app-type2-link-table>";